(ns com.theplantscape.calculate.ensemble
  (:require [com.theplantscape.calculate.core :as v]
            #?(:cljs [com.theplantscape.calculate.haversine :as h])))

(defn radius [[center-x center-y] [point-x point-y]] (v/radius [center-x center-y] [point-x point-y]))
(defn closest-value [target numbers] (v/closest-value target numbers))
(defn average-points [points] (v/average-points points))
(defn -vec [xy1 xy2] (v/-vec xy1 xy2))
(defn +vec [xy1 xy2] (v/+vec xy1 xy2))
(defn snap-grid [xy size snap] (v/snap-grid xy size snap))
(defn snap-closest-radius [center point radius-sequence] (v/snap-closest-radius center point radius-sequence))
(defn generate-radius [distance number] (v/generate-radius distance number))
(defn extend-line [[x1 y1] [x2 y2] extension-length] (v/extend-line [x1 y1] [x2 y2] extension-length))
(defn direction-vector [[x1 y1] [x2 y2]] (v/direction-vector [x1 y1] [x2 y2]))
(defn line-circle-intersection [[x1 y1] [x2 y2] [cx cy] r]
  (v/line-circle-intersection [x1 y1] [x2 y2] [cx cy] r))
(defn seq-min-max [m xy] (v/seq-min-max m xy))

#?(:cljs
   (defn distance-lat [lat1 lat2 conversion]
     (h/distance-lat lat1 lat2 conversion)))
#?(:cljs 
   (defn distance-long [lat1 lat2 conversion]
     (h/distance-long lat1 lat2 conversion)))
#?(:cljs 
   (defn distance-lat-long [latlng1 latlng2 conversion]
     (h/distance-lat-long latlng1 latlng2 conversion)))
